import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from "react-router";
import AppContainer from './AppContainer';
import Error from './Error';
import Done from './Done';
import GuideLogin from './GuideLogin.js';
import DownloadTheApp from './DownloadTheApp';
import BogglerTrails from './boggler-trails/App.jsx';
import TermsOfUse from './TermsOfUse';
import PrivacyPolicy from './PrivacyPolicy';
import { setLanguage } from './utils';
import { LanguageProvider } from './LanguageContext';
import ReScheduler from './ReScheduler';
import ResetPassword from './ResetPassword';
import ManageFinances from './ManageFinances';
import GuideProfile from './GuideProfile';
import AuthenticatedRoute from './AuthenticatedRoute';
import Phone from './Phone';
import ViewConversations from './ViewConversations';
import SignupInfluencer from './signupinfluencer/App.jsx';
import DmDilly from './dmdilly/App.jsx';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Helper to get query param
function getQueryParam(name) {
  const params = new URLSearchParams(window.location.search);
  return params.get(name);
}

let preferredLanguage = getQueryParam("lang") || 
    localStorage.getItem("buckish-language") || 
    (navigator.language.startsWith("si") ? "sinhala" : "english")


if (preferredLanguage === "sinhala") {
  document.documentElement.lang = "si";
}

//Temporarily set the language for the session to english 

setLanguage("english");

console.log("Language set to:", preferredLanguage);

const logOut = () => {
    const response = fetch(`${process.env.REACT_APP_API_URL}/guide/logout`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            token: window.localStorage.getItem('guideToken'),
            token_expiry: window.localStorage.getItem('guideTokenExpiry')
        }),
      })
      .then(response => response.json())
      .then(data => {
            // Handle successful logout
            window.localStorage.removeItem('guideToken');
            window.localStorage.removeItem('guideTokenExpiry');
            window.location.replace("/");
            console.log("guide logged out successfully");
      })
      .catch(error => {
          console.error("Error occurred during guide logout:", error);
      });
}

root.render(
  <React.StrictMode>
    <LanguageProvider>
      <BrowserRouter>
        <Suspense fallback={<div style={{ textAlign: 'center', marginTop: '50px', height: "100vh", width: "100vw" }}><div style={{position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)"}}><img src="https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/boggler-logo-clear.png" alt="Boggler Logo" /></div></div>}>
          <Routes>
            <Route element={<AppContainer />}>
              <Route index element={<GuideLogin />} />
              <Route 
                path="/download" 
                element={<DownloadTheApp />} />
              <Route 
                path="/profile" 
                element={<AuthenticatedRoute><GuideProfile logOut={logOut} /></AuthenticatedRoute>} />
              <Route
                path="/dmdilly"
                element={<AuthenticatedRoute><DmDilly /></AuthenticatedRoute>} />
              <Route
                path="/phone"
                element={<AuthenticatedRoute><Phone /></AuthenticatedRoute>} />
              <Route
                path="/conversations"
                element={<AuthenticatedRoute><ViewConversations /></AuthenticatedRoute>} />
              <Route
                path="/manage-finances"
                element={<AuthenticatedRoute><ManageFinances /></AuthenticatedRoute>} />
              <Route
                path="/guide/reset-password" 
                element={<ResetPassword />} />
              <Route 
                path="/boggler-trails" 
                element={<BogglerTrails />} />
              <Route 
                path="/done" 
                element={<Done />} />
              <Route 
                path="/signup/influencer" 
                element={<SignupInfluencer />} />
              <Route 
                path="/error" 
                element={<Error />} />
              <Route 
                path="/terms-of-use" 
                element={<TermsOfUse />} />
              <Route 
                path="/privacy-policy" 
                element={<PrivacyPolicy />} />
              <Route 
                path="/reschedule/:guideID/note/:noteID/confirm/:confirmationCode" 
                element={<ReScheduler />} />
              <Route
                path="*"
                element={<Error />}
              />
            </Route>
          </Routes>
        </Suspense>
      </BrowserRouter>
    </LanguageProvider>
  </React.StrictMode>
);
